import React from 'react';
import PalQuizListPage from './PalQuizListPage';

const TestsPage = () => {
  return <PalQuizListPage title="Tests" quizType="Tests" basePath="/pal/tests" />;
};

export default TestsPage;
